import { styled } from "styled-components";

export const Container = styled.div``;
export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
`;

export const Spacer = styled.span`
  margin: 30px;
`;

export const LeftSpacer = styled.span`
  margin-left: 10px;
`;

export const LeftFlexContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: flex-end;
  height: 28px;
  padding-bottom: 4px;
`;

export const TileTooltipContainer = styled.span`
  padding-left: 10px;
  height: 28px;
  display: flex;
  align-items: center;
`;

export const RightFlexContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const SelectContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  @media (max-width: 640px) {
    padding: 0 16px;
  }
`;

export const ComparedToContainer = styled.div`
  padding: 10px 0 10px 10px;
`;

export const SortContainer = styled.div`
  min-width: 200px;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-auto-flow: row;
  overflow-x: scroll;
`;

export const RowGrid = styled.div`
  display: flex;
  row-gap: 10px;
  column-gap: 20px;
  justify-content: start;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: start;
  column-gap: 10px;
  height: 24px;
`;
